import { NgModule, Component, Input, forwardRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	ControlValueAccessor,
	FormControl,
	FormsModule,
	NG_VALIDATORS,
	NG_VALUE_ACCESSOR,
	NgForm,
} from '@angular/forms';

import { Subscription } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from '@app/primeng-overrides/table';

import { GlobalModule } from '@global/global.module';

import { IPRequise } from '@app/abonne/abonne.model';
import { ipv4addressWithOptionalCidr } from '@helpers/utils';


@Component({
	selector: 'ip-form',
	 providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => IPFormComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => IPFormComponent),
			multi: true
		}
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './ip-form.html'
})
export class IPFormComponent implements OnInit, ControlValueAccessor {

	@Input() name: string;
	@Input('value') innerValue: IPRequise[];
	@Input() readonly: boolean;
	@Input() condensed: boolean = false;

	@ViewChild('ipForm', { static: true }) ipForm: NgForm;

	subscriptions: Subscription[] = [];

	ipPattern: string = `^${ipv4addressWithOptionalCidr}$`;

	constructor() {

	}

	ngOnInit() {
		this.subscriptions.push(
			// any time the inner form changes update the parent of any change
			this.ipForm.valueChanges!.subscribe((value: any) => {
				this.onChange(this.value);
				this.onTouched();
			})
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this.innerValue;
	}

	set value(value: IPRequise[]) {
		this.innerValue = value;
		this.onChange(value);
		this.onTouched();
	}

	registerOnChange(fn: Function) {
		this.onChange = fn;
	}

	registerOnTouched(fn: Function) {
		this.onTouched = fn;
	}

	writeValue(value: IPRequise[]) {
		if (typeof value != 'undefined') {
			this.innerValue = value;
		}
	}

	// communicate the inner form validation to the parent form
	validate(_: FormControl) {
		return this.ipForm.valid ? null : { ip: { valid: false } };
	}

	add() {
		this.value = [...this.value, {} as IPRequise];
	}

	delete(index: number) {
		this.value.splice(index, 1);
		this.value = [...this.value];
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		ButtonModule,
		InputTextModule,
		TableModule,
	],
	exports: [IPFormComponent],
	declarations: [IPFormComponent]
})
export class IPFormModule { }
